import React from 'react';
import { useLingui } from '@lingui/react/macro';
import { TabContent } from '@routes/profile-bar/___pages___/my-profile/styled.tsx';
import {
    TabContentInfoHeader,
    TabContentInfoText,
    TabContentInfoWrapper,
} from '@routes/profile-bar/___shared___/styled.tsx';

import MyLearningTable from './tables/my-learning';

const MyLearningTab: React.FC = () => {
    const { t } = useLingui();

    return (
        <TabContent>
            <TabContentInfoWrapper>
                <TabContentInfoHeader>{t`My learning`}</TabContentInfoHeader>
                <TabContentInfoText>{t`Log of activities`}</TabContentInfoText>
            </TabContentInfoWrapper>
            <MyLearningTable />
        </TabContent>
    );
};

export default MyLearningTab;
